import { useConfig } from "$global-providers/config-provider/provider";
import { useLazyUser } from "$global-providers/user-provider";
import useFacility from "$routes/_lib/use-facility";
import { linkToAdminControlPanel } from "$routes/admin/links";
import { linkToClinicAdminControlPanel } from "$routes/clinic-admin/links";
import { linkToPatientQueue } from "$routes/patient-queue-management/links";
import {
  linkToPatientSearch,
  linkToPatientSearchResults,
} from "$routes/patient-search/links";
import { linkToScanCard } from "$routes/scan-card/links";
import { linkToWardPatientList } from "$routes/ward-patient-list/links";
import { Freshdesk as BaseFreshdesk } from "./freshdesk-widget";

const clinicalHomepageActionsOverrides = {
  routes: [
    linkToPatientSearch(),
    linkToPatientSearchResults(),
    linkToPatientQueue(),
    linkToScanCard(),
    linkToWardPatientList(),
  ].map((path) => ({ path, exact: true })),
  defaultStyle: {
    right: "104px",
  },
  breakpoints: [
    {
      maxWidth: "599.95px",
      style: {
        right: "20px",
        bottom: "72px",
      },
    },
  ],
};

export const Freshdesk: FC = () => {
  const {
    territory,
    freshdesk: { host, token },
    environment,
  } = useConfig();
  const user = useLazyUser();
  const { data: facilityData } = useFacility();

  if (!user || !facilityData) {
    return null;
  }

  return (
    <BaseFreshdesk
      freshdeskToken={token}
      freshdeskHost={host}
      context={{
        user: {
          id: user.id,
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          roleName: user.role,
          facilityName: facilityData.name,
          facilityId: facilityData.id,
          organisationId: facilityData.organisation,
        },
        territory,
        environment,
      }}
      activeRoutes={[
        { path: linkToPatientSearch(), exact: false },
        { path: linkToPatientQueue(), exact: false },
        { path: linkToScanCard(), exact: false },
        { path: linkToWardPatientList(), exact: false },
        { path: linkToClinicAdminControlPanel(), exact: true },
        { path: linkToAdminControlPanel(), exact: true },
      ]}
      positionOverrides={[clinicalHomepageActionsOverrides]}
    />
  );
};
